var $a38b6c4e18725976$exports = {};
$a38b6c4e18725976$exports = {
  "Empty": "\u041D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E"
};
export { $a38b6c4e18725976$exports as default };